// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/layout/UserArea.module.css';
import CompanionSessionStore from '@app/features/companion/state/CompanionSessionStore';
import FocusRing from '@app/features/ui/focus_ring/FocusRing';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {SparkleIcon} from '@phosphor-icons/react';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

export const CompanionUserControl = observer(function CompanionUserControl() {
	const {i18n} = useLingui();
	return (
		<Tooltip text={i18n._(msg({message: 'AI companion'}))} data-flx="companion.companion-user-control.tooltip">
			<FocusRing offset={-2} data-flx="companion.companion-user-control.focus-ring">
				<button
					type="button"
					className={clsx(styles.controlButton, CompanionSessionStore.hasActiveSession && styles.companionActive)}
					aria-label={i18n._(msg({message: 'Open AI companion'}))}
					aria-pressed={CompanionSessionStore.isPanelOpen}
					onClick={CompanionSessionStore.togglePanel}
					data-flx="app.user-area.companion-button"
				>
					<SparkleIcon
						weight="fill"
						className={styles.controlIcon}
						aria-hidden="true"
						data-flx="companion.companion-user-control.control-icon"
					/>
					{CompanionSessionStore.hasActiveSession && (
						<span
							className={styles.companionIndicator}
							aria-hidden="true"
							data-flx="companion.companion-user-control.companion-indicator"
						/>
					)}
				</button>
			</FocusRing>
		</Tooltip>
	);
});
